import React from 'react';
import { motion } from 'framer-motion';
import { Rocket, Scale, Building2, Users, Briefcase, TrendingUp } from 'lucide-react';
import { slideUp } from '../utils/animations';
const audiences = [{
  icon: Rocket,
  title: 'Founders & Startups',
  desc: 'Protect your brand from day one',
  gradient: 'from-orange-500 to-red-500'
}, {
  icon: Scale,
  title: 'Legal Teams',
  desc: 'Automate IP enforcement',
  gradient: 'from-blue-500 to-indigo-500'
}, {
  icon: Building2,
  title: 'Enterprises',
  desc: 'Manage global trademark portfolios',
  gradient: 'from-violet-500 to-purple-500'
}, {
  icon: TrendingUp,
  title: 'Ecommerce Brands',
  desc: 'Stop marketplace counterfeits',
  gradient: 'from-green-500 to-emerald-500'
}, {
  icon: Briefcase,
  title: 'IP Professionals',
  desc: 'Monitor multiple client assets',
  gradient: 'from-cyan-500 to-blue-500'
}, {
  icon: Users,
  title: 'Agencies',
  desc: 'Offer brand protection services',
  gradient: 'from-pink-500 to-rose-500'
}];
export function AudienceSection() {
  return <section className="py-20 md:py-24 bg-slate-50 relative overflow-hidden" data-id="element-1">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-40" data-id="element-2">
        <div className="absolute inset-0 bg-[radial-gradient(#e5e7eb_1px,transparent_1px)] [background-size:20px_20px]" data-id="element-3"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-4">
        <div className="text-center mb-12 md:mb-16" data-id="element-5">
          <motion.h2 initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={slideUp} className="text-3xl sm:text-4xl md:text-5xl font-bold text-slate-900 mb-4 tracking-tight" data-id="element-6">
            Built for everyone who values <br className="hidden sm:block" data-id="element-7" />
            <span className="text-indigo-600" data-id="element-8">their brand</span>
          </motion.h2>
          <motion.p initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={slideUp} className="text-base md:text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-9">
            From solo founders to Fortune 500 legal teams—trademark protection
            for all.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-10">
          {audiences.map((item, index) => <motion.div key={item.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.08
        }} whileHover={{
          y: -8,
          scale: 1.02
        }} className="group relative bg-white rounded-2xl p-6 md:p-8 shadow-lg border border-slate-100 hover:shadow-2xl hover:border-indigo-100 transition-all duration-300 cursor-default overflow-hidden" data-id="element-11">
              {/* Gradient Background on Hover */}
              <div className={`absolute inset-0 bg-gradient-to-br ${item.gradient} opacity-0 group-hover:opacity-5 transition-opacity duration-300`} data-id="element-12" />

              <div className="relative z-10" data-id="element-13">
                <motion.div whileHover={{
              rotate: [0, -10, 10, -10, 0],
              scale: 1.1
            }} transition={{
              duration: 0.5
            }} className={`w-14 h-14 rounded-xl bg-gradient-to-br ${item.gradient} flex items-center justify-center text-white shadow-lg mb-4 group-hover:shadow-xl`} data-id="element-14">
                  <item.icon className="w-7 h-7" data-id="element-15" />
                </motion.div>

                <h3 className="text-xl font-bold text-slate-900 mb-2 group-hover:text-indigo-600 transition-colors" data-id="element-16">
                  {item.title}
                </h3>
                <p className="text-slate-600 leading-relaxed" data-id="element-17">{item.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}